export default __webpack_public_path__ + "static/img-3-d1886e255c14d2e05df5212cf058f166.png";